import segerinProject from "../images/segerin.png";
import travelokaProject from "../images/travelokaProject.png";
import mendixLogo from "../images/mendixLogo.png";
import kmbdLogo from "../images/kmbdLogo.jpg";
import tfiLogo from "../images/tfiLogo.png";
import figmaLogo from "../images/figmaLogo.png";
import movistaProject from "../images/movista.png";
import fggProject from "../images/fggProject.png";
import kalbeFarma from "../images/kalbeFarma.png";
import bca from "../images/bca.png";
import btn from "../images/btnLogo.webp";
import bri from "../images/briLogo.png";
import katalonLogo from "../images/katalonLogo.png";
import seleniumLogo from "../images/seleniumLogo.png";
import k6Logo from "../images/k6Logo.png";
import playwrightLogo from "../images/playwrightLogo.png";
import appiumLogo from "../images/appiumLogo.png";
import cssLogo from "../images/cssLogo.jpg";
import jsLogo from "../images/jsLogo.png";
import htmlLogo from "../images/htmlLogo.jpg";
import reactJsLogo from "../images/reactJsLogo.png";
import javaLogo from "../images/javaLogo.webp";
import mysqlLogo from "../images/mysqlLogo.png";
// document
import resume from "../doc/Arjuna-QualityAssurance.pdf";
import antiBullying from "../doc/antiBullying.pdf";
import batikCulture from "../doc/batikCulture.pdf";
import religiousModeration from "../doc/religiousModeration.pdf";
import certifKMBD from "../doc/Certificate_KMBD.pdf";
import InternshipCertif from "../doc/Internship_Certif.pdf";

export const Bio = {
  name: "Arjuna",
  roles: ["Banking & ERP Systems", "Manual & Automation Testing"],
  description:
    "Quality Assurance Analyst with experience in banking and ERP systems. Started as a Manual Tester and grew into a QA Analyst, specializing in requirement analysis, API testing, automation, and end-to-end system validation. Passionate about delivering reliable, high-quality software in Agile environments.",
  github: "https://github.com/Arj573",
  resume: resume,
  linkedin: "https://www.linkedin.com/in/arjuna2003",
  twitter: "https://twitter.com/arjwijya",
  insta: "https://www.instagram.com/arjwijya/",
  facebook: "https://www.facebook.com/arjuna.wijaya.54966834?mibextid=ZbWKwL",
  git: "https://github.com/Arj573",
};

export const skills = [
  {
    title: "Software Tester",
    skills: [
      {
        name: "Katalon",
        image: katalonLogo,
      },
      {
        name: "K6",
        image: k6Logo,
      },
      {
        name: "Selenium",
        image: seleniumLogo,
      },
      {
        name: "Playwright",
        image: playwrightLogo,
      },
      {
        name: "Appium",
        image: appiumLogo,
      },
    ],
  },
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image: reactJsLogo,
      },
      {
        name: "HTML",
        image: htmlLogo,
      },
      {
        name: "CSS",
        image: cssLogo,
      },
      {
        name: "JavaScript",
        image: jsLogo,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Figma",
        image: figmaLogo,
      },
      {
        name: "Java",
        image: javaLogo,
      },
      {
        name: "MySQL",
        image: mysqlLogo,
      },
      {
        name: "Mendix",
        image: mendixLogo,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: kmbdLogo,
    role: "Competition Division Coordinator",
    company: "KMB Dhammavaddhana BINUS",
    date: "Nov 2021 - May 2022",
    desc: "Contribute to the 2022 Nusantara Buddhist Festival as Competition Division Coordinator, from creating competition forms to supervising the competition",
    skills: ["Team Work", "Management Plan", "Content Design", "Communication"],
    doc: certifKMBD,
  },
  {
    id: 1,
    img: tfiLogo,
    role: "Volunteer regarding anti-bullying education",
    company: "TFI Powered by Bina Nusantara",
    date: "Dec 2022 - Feb 2023",
    desc: "Become a volunteer in explaining an anti-bullying topic that often occurs among children and teenagers, in an orphanage foundation",
    doc: antiBullying,
    skills: [
      "Team Work",
      "Public Relationship",
      "Communication",
      "Management Plan",
    ],
  },
  {
    id: 2,
    img: tfiLogo,
    role: "Volunteer Socialization about Batik Culture",
    company: "TFI Powered by Bina Nusantara",
    date: "Apr 2023 - Jul 2023",
    desc: "Become a volunteer in social activities to educate a community about Batik Cultural Socialization",
    doc: batikCulture,
    skills: [
      "Team Work",
      "Public Relationship",
      "Communication",
      "Management Plan",
    ],
  },
  {
    id: 3,
    img: tfiLogo,
    role: "Volunteer for the introduction of religious moderation",
    company: "TFI Powered by Bina Nusantara",
    date: "Sep 2023 - Jan 2024",
    desc: "Become a volunteer in social activities to educate the public about the socialization of religious moderation.",
    doc: religiousModeration,
    skills: [
      "Team Work",
      "Public Relationship",
      "Communication",
      "Management Plan",
    ],
  },
  {
    id: 4,
    img: kalbeFarma,
    role: "Quality Assurance - Intern",
    company: "PT Kalbe Farma, Tbk",
    date: "Feb 2024 - Apr 2025",
    desc: "Progressed through end-to-end testing activities within ERP-based systems, contributing to structured quality assurance processes in a pharmaceutical enterprise environment.",
    highlights: [
      "Preparing essential documents such as standards, test plans, issue logs, and user matrices to ensure a structured and well-documented testing process",
      "Applying automation tools to various test cases to enhance efficiency and accuracy in the testing process",
      "Testing the functionality and security of APIs to ensure smooth system integration using Postman",
      "Using JMeter and k6 to assess application performance and ensure the system can handle varying load levels",
      "Performing penetration testing using i3GIS to identify potential vulnerabilities and improve application security",
      "Developing dashboards that list all projects to facilitate effective tracking, monitoring, and project data management",
    ],
    doc: InternshipCertif,
    skills: [
      "Automation testing",
      "Manual testing",
      "Stress testing",
      "Performance testing",
    ],
  },
  {
    id: 5,
    img: bca,
    role: "Quality Assurance Analyst",
    company: "PT Bank Central Asia Tbk",
    date: "May 2025 - Present",
    desc: "Promoted from Manual Tester to QA Analyst, responsible for leading UAT, executing SIT and API testing, maintaining structured test documentation, and collaborating with business and technical stakeholders to ensure high-quality banking system releases.",
    highlights: [
      "Led and executed User Acceptance Testing (UAT) from scenario design to test execution",
      "Conducted API testing to validate system integrations across banking platforms",
      "Designed and maintained comprehensive test documentation ensuring traceability and coverage",
      "Performed System Integration Testing (SIT) and regression testing for banking applications",
      "Collaborated with business users, developers, and analysts to align testing objectives with project goals",
      "Provided analytical insights and improvement recommendations to enhance product quality and testing efficiency",
    ],
    doc: "/",
    skills: [
      "Automation testing",
      "Manual testing",
      "Communication",
      "Back-end testing",
    ],
  },
  {
    id: 6,
    img: btn,
    role: "Quality Assurance Analyst",
    company: "PT Bank Tabungan Negara Tbk",
    date: "May 2026 - July 2026",
    desc: "Performed User Acceptance Testing (UAT), API testing using Postman, end-to-end testing, defect analysis, and cross-functional collaboration to ensure the quality, reliability, and successful delivery of banking applications.",
    highlights: [
      "Conduct User Acceptance Testing (UAT) activities, including test scenario preparation, execution, and result validation to ensure system quality and business requirement alignment.",
      "Perform API testing using Postman to validate system integration, endpoint functionality, and data accuracy.",
      "Collaborate with business users, developers, and project stakeholders to identify issues and ensure smooth implementation delivery.",
      "Analyze testing results, document defects, and provide detailed reports for issue tracking and resolution.",
      "Support end-to-end testing processes across banking applications to maintain system stability and reliability.",
      "Contribute to QA documentation and continuous improvement initiatives within the testing process.",
    ],
    doc: "/",
    skills: [
      "Automation testing",
      "Manual testing",
      "Communication",
      "Back-end testing",
      "Agile methodology",
    ],
  },
  {
    id: 7,
    img: bri,
    role: "Quality Assurance Engineer",
    company: "PT Bank Rakyat Indonesia Tbk",
    date: "July 2026 - Present",
    desc: "Performed User Acceptance Testing (UAT), API testing using Postman, end-to-end testing, defect analysis, and cross-functional collaboration to ensure the quality, reliability, and successful delivery of banking applications.",
    highlights: [
      "Developed and maintained automated test scripts using Katalon Studio with the BDD Cucumber framework to ensure application quality and functionality.",
      "Conducted performance testing using ghz to evaluate system performance, reliability, and response behavior under various workloads.",
      "Prepared and maintained QA documentation, including test cases, test results, and defect reports to support testing activities.",
      "Collaborated with cross-functional teams within an Agile development environment to ensure timely and high-quality software delivery.",
    ],
    doc: "/",   
    skills: [
      "Automation testing",
      "Performance testing",
      "Communication",
      "Back-end testing",
      "Agile methodology",
    ],
  },
];

export const projects = [
  {
    id: 0,
    title: "Ticks",
    date: "Jan 2023 - April 2023",
    description:
      "Ticks is a concert ticket sales website, where users can see available concert tickets directly via the home page and ticket page, plus a promotion page to see available promotions",
    image:
      "https://github.com/Arj573/Ticks/blob/main/assets/images/Ticks_Preview.png?raw=true",
    tags: ["HTML", "CSS", "Java Script"],
    category: "web app",
    github: "https://github.com/Arj573/Ticks",
    webapp: "https://ticks-tawny.vercel.app/",
  },
  {
    id: 1,
    title: "Traveloka Clone",
    date: "Feb 2023 - April 2023",
    description:
      "I cloned Traveloka by making all the UI available for each application feature. Starting from designing the landing page, navbar and designing the available pages. In this project I act as a flight feature designer.",
    image: travelokaProject,
    tags: ["Figma"],
    category: "design",
    github: "/",
    webapp:
      "https://www.figma.com/proto/esCOQPIcKQaoherjcPZpKE/UXPROJECT?node-id=99-41&starting-point-node-id=10%3A4&mode=design&t=UpcBBOLD82zaSQ7l-1",
  },
  {
    id: 2,
    title: "FGG App",
    date: "Aug 2023 - Jan 2024",
    description:
      "FGG (Fresh Graduate Guidelines) is an application created to help new graduates search for or find jobs that suit their desired interests. Currently the application is still in the prototype design stage.",
    image: fggProject,
    tags: ["Figma"],
    category: "design",
    github: "/",
    webapp:
      "https://www.figma.com/proto/DjldXdjcAz3JOTIE41W658/BJ11---3---Prototype-FGG-App?page-id=0%3A1&type=design&node-id=1-248&viewport=591%2C278%2C0.09&t=fEPv4P874iKxj7lx-1&scaling=scale-down&starting-point-node-id=1%3A168&show-proto-sidebar=1",
  },
  {
    id: 3,
    title: "Movista",
    date: "Sept 2023 - Jan 2024",
    description:
      "Movista is an application that operates in the field of video on demand. This application is designed to make it easier for users to search for/watch films online. However, currently the manufacturing stage is still in the prototype stage.",
    image: movistaProject,
    tags: ["Mendix", "CSS"],
    category: "mobile app",
    github: "/",
    webapp: "/",
    // member: [
    //   {
    //     name: "Arjuna",
    //     img: "",
    //     linkedin: "",
    //     github: "",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },
  {
    id: 4,
    title: "Segerin",
    date: "Sept 2023 - Jan 2024",
    description:
      "SEGERIN is a business that provides various drinks with a summer theme aims to provide a fresh sensation when it is hot day. SEGERIN will also be implemented digitally use website technology to place orders and see the various menus available. So with With this website, potential customers can also see it various promotions and menus available",
    image: segerinProject,
    tags: ["React JS", "HTML", "CSS", "JS"],
    category: "web app",
    github: "https://github.com/Arj573/Segerin.git",
    webapp: "https://segerin.vercel.app/",
  },
];
